<template>
  <el-row :class="{ region: $store.getters.roleType === 'region' }">
    <el-row class="entry" v-if="roleId !== 40001">
      <p class="title" v-if="filterEntry.length">快捷入口</p>
      <el-row class="cards">
        <div v-for="(item, index) in filterEntry" :key="index">
          <div
            v-if="(item.path !== 'mlz' && item.path !== 'courseIntro')"
            :span="4"
            class="card"
            :style="{ background: item.background }"
            @click="router(item.path)"
          >
            <div
              class="corner-icon"
              :style="{ 'background-image': `url(${item.cornerIcon})` }"
            ></div>
            <el-tooltip
              class="item"
              effect="dark"
              content="版本已更新 请下载最新版本"
              placement="right-start"
            >
              <div v-if="item.name === '离线创作工具'" class="new_tips"></div>
            </el-tooltip>
            <div
              v-if="item.position"
              class="entry-icon"
              :style="{ 'background-position': item.position }"
            ></div>
            <p class="item">{{ item.name }}</p>
          </div>
          <!--   1、只有学校可见 2、教师、教官一直可见 3、学生有开通双师班显示   -->
          <div
            class="card"
            v-if="
              item.path === 'mlz' &&
              ((unitType === 1001 && roleId !== 20001) || (roleId === 20001 && isOpenDouble))
            "
            :style="{ background: item.background }"
            @click="router('mlz')"
          ></div>
          <!--   1、只有学校可见 2、教师、教官一直可见 3、学生有开通双师班显示   -->
          <div
            class="card"
            v-if="
              item.path === 'courseIntro' &&
              ((unitType === 1001 && roleId !== 20001) || (roleId === 20001 && isOpenDouble))
            "
            :style="{ background: item.background }"
            @click="router('courseIntro')"
          ></div>
        </div>
      </el-row>
    </el-row>

    <div :class="['black-board', { 'unit-black-board': roleId === 40001 }]" v-if="blackboard">
      <p class="title">
        小黑板
        <router-link
          v-if="$store.getters.roleType !== 'region'"
          :to="{ name: $store.getters.roleType !== 'student' ? 'workManage' : 'myWork' }"
        >
          查看更多
          <i class="el-icon-arrow-right"></i>
        </router-link>
      </p>
      <el-card>
        <div class="flex">
          <div class="work" v-for="(item, index) in blackboard" :key="index">
            <div>
              <span>{{ item.role_id === 20001 ? '学生' : '教师' }}</span>
              <span class="work-author">{{ item.name }}</span>
              {{ item.status | filterOperation }}作品
              <span
                class="work-release"
                :class="{
                  'work-no-open':
                    item.work_type === 7 || item.work_status === -99 || item.work_status === -100
                }"
                @click="checkWorks(item)"
                >{{ item.work_name }}</span
              >
            </div>
            <div class="time">{{ formatDate(item.created_time) }}</div>
          </div>
        </div>
      </el-card>
    </div>

    <el-row
      :gutter="30"
      type="flex"
      :class="{ card_containerXL: roleId === 40001 }"
      class="card_container"
    >
      <el-col
        v-if="$store.getters.roleType && $store.getters.roleType !== 'region'"
        :span="12"
        style="height: 100%"
      >
        <p class="title">创作工具</p>
        <el-card>
          <div class="tools">
            <ul>
              <li @click="routerTo('ide')">
                <img
                  width="150"
                  src="https://public-static-edu.codemao.cn/redboat/static/kitten-new200.png"
                  alt="ide"
                />
                <h5>2D创作工具</h5>
                <p>源码编辑器</p>
              </li>
              <li @click="routerTo('box')">
                <img
                  width="150"
                  src="https://public-static-edu.codemao.cn/redboat/static/box2.0-new200.png"
                  alt="ide"
                />
                <h5>3D创作工具</h5>
                <p>代码岛2.0</p>
              </li>
            </ul>
            <router-link to="tool">
              <el-button type="primary">更多工具</el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" style="height: 100%">
        <p class="title">信息栏</p>
        <el-card>
          <div class="info-card">
            <div
              class="info"
              :class="{ info_containerXL: roleId === 40001, 'cursor-pointer': item.url }"
              v-for="(item, index) in scoreBoard"
              :key="index"
              @click="item.url && $router.push(item.url)"
              :style="{
                'background-image': `url(${item.backgroundIcon})`,
                'background-size': `${item.backgroundIconPosition}`
              }"
            >
              <template v-if="item.name !== '上课数'">
                <el-tooltip
                  v-if="item.name === '激活学生数'"
                  content="学生首次成功进入“点猫编程平台”即为激活状态"
                  placement="top"
                >
                  <span class="class">{{ item.name }}</span>
                </el-tooltip>
                <span v-else class="class">{{ item.name }}</span>
                <el-rate
                  v-model="item.rate"
                  disabled
                  :show-score="false"
                  text-color="#ff9900"
                  :show-text="false"
                  v-if="item.name === '作品平均分' || item.name === '作品最高分'"
                ></el-rate>
                <count-up
                  v-else
                  class="text"
                  :id-name="item.name"
                  :end-val="item.value"
                  :count-unit="item.unit"
                  :color="roleId === 40001 ? item.unitTextColor : 'block'"
                  countSize="30px"
                  :countWeight="400"
                ></count-up>
                <div
                  class="add"
                  v-if="item.hasOwnProperty('addedYesterdayName')"
                  :style="{ color: item.unitTextColor }"
                >
                  昨日新增 +<span>{{ item.addedYesterdayName }}</span>
                </div>
              </template>
              <template v-else>
                <el-tooltip content="根据教师向班级发送课程资料的课程数统计" placement="top">
                  <span class="class">{{ item.name }}</span>
                </el-tooltip>
                <count-up
                  class="text"
                  :id-name="item.name"
                  :end-val="item.value"
                  :count-unit="item.unit"
                  :color="roleId === 40001 ? item.unitTextColor : 'block'"
                  countSize="30px"
                  :countWeight="400"
                ></count-up>
              </template>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <outline-download-model
      @closeModel="closeModel"
      :showModel="showModel"
    ></outline-download-model>

    <common-modal v-model="showModal" :title="modalTitle" :show-close="showClose">
      <double slot="content" v-if="modalType === '双师'" />
      <invite-message
        slot="content"
        v-if="modalType === '学生收到邀请'"
        :inviteData="inviteData"
        @getInviteMessage="getInviteMessage"
        @closeModal="closeModal"
      />
    </common-modal>
    <common-modal :width="630" v-model="showTeachingModal" title="上课提醒" show-close>
      <teaching-modal slot="content" :teachingInfo="teachingInfo" />
    </common-modal>
    <course-intro-modal
      :show-close="closeCourseModel"
      v-model="showCourseModel">
    </course-intro-modal>
  </el-row>
</template>

<style lang="scss" scoped>
@import './dashboard';
</style>

<script>
import CountUp from '@/components/countUp'
import { formatDate, workScoreFilter, detectOS } from '@/utils/utils'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import { getTeachingNotice } from '@/apis/teaching'

export default {
  components: {
    CountUp,
    outlineDownloadModel: () =>
      import('./outlineDownloadModel.vue' /* webpackChunkName: "outlineDownloadModel" */),
    CommonModal: () => import('@/components/commonModal' /* webpackChunkName: "CommonModal" */),
    Double: () => import('./double' /* webpackChunkName: "Double" */),
    InviteMessage: () => import('./modal/inviteMessage' /* webpackChunkName: "InviteMessage" */),
    TeachingModal: () => import('./modal/teachingModal'),
    CourseIntroModal: () => import('./modal/courseIntroModal')
  },
  data() {
    return {
      infoList: [
        {
          label: '班级数',
          value: '30',
          icon: 'classNum'
        },
        {
          label: '学生数',
          value: '130',
          icon: 'student'
        },
        {
          label: '作品数',
          value: '2330',
          icon: 'info'
        },
        {
          label: '作品平均分',
          value: '93',
          icon: 'score'
        },
        {
          label: '作品最高分',
          value: '100',
          icon: 'highest'
        }
      ],
      test: {
        student_num: '150',
        class_num: '200',
        work_num: '300',
        avarage_score: '200',
        high_score: '200'
      },
      showModel: false,
      showCourseModel: false,
      showDialog: false,
      modalTitle: '',
      modalType: '',
      isOpenDouble: false, // 是否开通双师班
      inviteData: {},
      showClose: true,
      showTeachingModal: false,
      teachingInfo: {}
    }
  },
  filters: {
    filterOperation(id) {
      switch (id) {
        case 1001:
          return '保存了'
        case 1002:
          return '发布了'
        case 2001:
          return '更新了'
        case 2002:
          return '更新了'
        case 2003:
          return '更新了'
        case 4001:
          return '删除了'
        case 4002:
          return '删除了'
        case 5001:
          return '评价了'
      }
    }
  },
  created() {
    this.$store.dispatch('getStatistic')
    this.$store.dispatch('reportClassroomPageVisit')
    this.$store.dispatch('getUnreadMessage')
    this.$store.dispatch('getHelpRedInfo')
    if (this.roleId === 20001) this.getInviteMessage()
    // 首页到点击课程包详情页视频按钮
    this.$store.dispatch('startIndexToPlayVideo')
    // 学生端获取上课提醒
    this.getTeachingNotice()
  },
  methods: {
    async router(path) {
      switch (path) {
        case 'offlineTool':
          this.showModel = true
          break
        case 'forum':
          window.open(window.CONFIG.forum)
          break
        case 'tower':
          this.routerTo('tower', true)
          break
        case 'studentForum':
          window.open(window.CONFIG.community)
          break
        case 'contestCenter':
          this.$store.dispatch('handleCheckSkipModal', { element: '赛事中心' }).then((res) => {
            res && this.$router.push({ name: 'selectMatch' })
          })
          // window.open(window.CONFIG.contest)
          break
        case 'mlz':
          this.$store.dispatch('handleCheckSkipModal', { element: 'AI双师' }).then((res) => {
            if (res) {
              // 已开通双师班且为教官、教师身份
              if (this.isOpenDouble && (this.roleId === 10001 || this.roleId === 10002)) {
                this.$router.push('/mlzTeacher')
              } else if (!this.isOpenDouble && (this.roleId === 10001 || this.roleId === 10002)) {
                this.modalTitle = '提示'
                this.modalType = '双师'
                this.showModal = true
              } else if (this.roleId === 20001) {
                window.open(`${CONFIG.ai_class}`)
              }
            }
          })
          break
        case 'courseIntro': // 课程体系介绍
          this.showCourseModel = true
          break
        default:
          this.$router.push({ name: path })
      }
    },
    async routerTo(item, param = false) {
      window.open(
        CONFIG[item] +
          (param
            ? '?source=classroom_homepage_entrance&utm_source=edu&utm_medium=web&utm_campaign=homepage'
            : '')
      )
    },
    // 获取邀请信息
    async getInviteMessage() {
      const { status, data } = await this.$store.dispatch('getInviteMessage')
      if (status === 200 && data) {
        this.modalTitle = ''
        this.modalType = '学生收到邀请'
        this.inviteData = data
        this.showClose = false
        this.showModal = true
      }
    },
    formatDate(date) {
      return formatDate(date)
    },
    closeModel() {
      this.showModel = false
    },
    closeCourseModel() {
      this.showCourseModel = false
    },
    closeModal() {
      this.showModal = false
    },
    async checkWorks(work) {
      const type = work.work_type
      if (work.work_status === 1) {
        if (type === 1 || type === 4 || type === 6 || type === 0) {
          window.open(`${CONFIG.ide_player}/we/${work.work_id}`)
        } else if (type === 5) {
          window.open(`${CONFIG.box}/w/${work.work_id}`)
        }
      } else {
        window.open(`${window.CONFIG.lab}/work/${work.work_id}`)
      }
    },
    download() {
      const os = detectOS()
      if (/XP/.test(os)) {
        window.open('http://down.codemao.cn/forwin/chrome/chrome-49.exe')
      } else {
        window.open('http://7xns6d.dl1.z0.glb.clouddn.com/chrome/download/googlechrome.exe')
      }
    },
    async getTeachingNotice() {
      if (this.roleId !== 20001) return
      const { hasTeachingClass, teachingInfo } = await getTeachingNotice()
      if (hasTeachingClass) {
        this.showTeachingModal = true
        this.teachingInfo = teachingInfo
      }
    }
  },
  computed: {
    // 入口
    ...mapState(['user', 'dashboard']),
    entry() {
      return this.dashboard.entry
    },
    filterEntry() {
      return this.dashboard.entry.filter((v) =>
        ['tower', 'studentForum', 'forum', 'mlz', 'offlineTool', 'contestCenter', 'courseIntro'].includes(v.path)
      )
    },
    scoreBoard() {
      const data = cloneDeep(this.dashboard.scoreBoard)
      data.forEach((value) => {
        value.rate = workScoreFilter(value.value)
      })
      return data
    },
    roleId() {
      return this.user.role_id
    },
    blackboard() {
      return this.dashboard.blackboard
    },
    showModal: {
      get() {
        return this.dashboard.showModal
      },
      set(showModal) {
        this.$store.commit('setState', {
          module: 'dashboard',
          key: 'showModal',
          value: showModal
        })
      }
    },
    unitType() {
      return this.user.unit_type_id
    }
  },
  async mounted() {
    const roleId = [10001, 10002, 20001]
    if (roleId.includes(this.roleId)) {
      const { status, data } = await API.get('/edu/zone/shuangshi/check')
      if (status === 200) {
        this.isOpenDouble = data.shuangshi_open_flag
      }
    }
  }
}
</script>
